import { render, staticRenderFns } from "./layout-card-wrap.vue?vue&type=template&id=1f8937f7&scoped=true&"
import script from "./layout-card-wrap.vue?vue&type=script&lang=js&"
export * from "./layout-card-wrap.vue?vue&type=script&lang=js&"
import style0 from "./layout-card-wrap.vue?vue&type=style&index=0&id=1f8937f7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8937f7",
  null
  
)

export default component.exports